import styled from 'styled-components';
import { useNavigate, useParams } from 'react-router-dom';

import { FormHeader } from '../../styled';
import { primaryColor } from '~theme';
import { Button } from '~ui-kit';
import { config } from '../../../configuration';

const Summary = props => {
  const { id } = useParams();
  const { title, path } = props;

  const navigate = useNavigate();

  return (
    <Wrapper>
      <FormHeader className="col-xs-12 col-sm-8">{title}</FormHeader>

      <Body className="col-xs-12 col-sm-12 col-lg-12">
        <Paragraph>Tilaus onnistui.</Paragraph>
        <Paragraph>Voit seurata tilauksen statusta tilauslistasta.</Paragraph>
      </Body>

      <div className="col-xs-12 col-md-6 col-lg-6">
        <CustomButtons>
          <Button
            w="50%"
            minWidth="200px"
            secondary
            onClick={() => navigate(`/palvelut/${path}`)}
          >
            Tee uusi tilaus
          </Button>
          {!window.cordova && (
            <LinkButton
              href={`${config.apiUrl}orders/pdf/${id}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button w="50%" minWidth="200px" secondary>
                Tulosta tilaus
              </Button>
            </LinkButton>
          )}
          <Button w="50%" minWidth="200px" cancel onClick={() => navigate('/')}>
            Palaa takaisin alkuun
          </Button>
        </CustomButtons>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div``;

const Body = styled.div`
  /* margin: 32px 0; */
`;

const Paragraph = styled.p`
  color: ${primaryColor};
  margin: 16px 0;
`;

const CustomButtons = styled.div`
  display: flex;
  flex-direction: column;
  > * {
    margin: 10px 0;
  }
`;

const LinkButton = styled.a`
  width: unset;
`;

export default Summary;
